import $ from "jquery";
import { InCoreSwal2, InCoreSwal2Icon } from "./swal.utils";

/**
 * Initializes tab panels and handles automatic tab switching.
 */
export function initializeTabPanels(): void {
    $(() => {
        // Initialize tab panels for buttons with `data-tab` attribute
        $("button[data-tab]").each(function () {
            const id = $(this).attr("id");
            if (id) {
                activateTabPanel(id);
            }
        });

        // Handle automatic tab switching based on URL parameters
        handleAutomaticTabSwitch();
    });
}

/**
 * Handles automatic tab switching based on the `tab` parameter in the URL.
 */
function handleAutomaticTabSwitch(): void {
    const matches = /tab=([^&#=]*)/.exec(window.location.href);
    if (matches) {
        const tab = matches[1];
        if (tab) {
            const button = $(`#btn${tab}`);
            if (button.length) {
                $("button.active").removeClass("active");
                $(".tab-pane.show.active").removeClass("show active");
                button.addClass("active");
                $(button.data("bs-target")).addClass("show active");
                const hash = window.location.hash;

                if (hash) {
    
    const element = document.querySelector(hash);

    if (element) {
        const y = element.getBoundingClientRect().top + window.scrollY - 80;

        window.scrollTo({
            top: y,
            behavior: "smooth"
        });
    }

}

                if (button.is("[data-tab]")) {
                    button.each(function () {
                        const id = $(this).attr("id");
                        if (id) {
                            activateTabPanel(id);
                        }
                    });
                }
            }
        }
    }
}

/**
 * Activates a tab panel for a specific button.
 * @param {string} id - The ID of the button.
 */
export function activateTabPanel(id: string): void {
    const button = $(`#${id}`);

    // Extract attributes for AJAX call
    const controller = button.data("controller");
    const action = button.data("action");
    const param = button.data("param");
    const panelId = button.attr("aria-controls");
    const name = button.html();

    button.on("click", function () {
        handleTabClick(button, name, controller, action, param , panelId ?? "");
    });
}

/**
 * Handles the click event for a tab panel button.
 * @param {JQuery} button - The button element.
 * @param {string} name - The button's original name.
 * @param {string} controller - The controller name for the AJAX call.
 * @param {string} action - The action name for the AJAX call.
 * @param {string | undefined} param - Additional parameters for the AJAX call.
 * @param {string} panelId - The ID of the panel to update.
 */
function handleTabClick(
    button: JQuery,
    name: string,
    controller: string,
    action: string,
    param: string | undefined,
    panelId: string
): void {
    // Disable the button to prevent multiple clicks
    button.prop("disabled", true);

   // Perform the AJAX call
    performAjaxCall(controller, action, param)
        .then((data) => {
            // Update the panel content
            $(`#${panelId}`).html(data);

            // Remove the loading spinner and restore the button's original content
            button.empty().html(name);

            // Execute any scripts in the loaded content
            $(data)
                .find("script")
                .each((_, script) => {
                    const scriptElement = $("<script>").text($(script).text());
                    $(`#${panelId}`).append(scriptElement);
                });

            // Re-enable the button
            button.prop("disabled", false);
        })
        .catch(() => {
            // Handle errors
            button.empty().html(name);
            button.prop("disabled", false);
            InCoreSwal2(InCoreSwal2Icon.Error, "Ops! Errore nel caricamento della scheda. Ci scusiamo per il disagio.");
        });
}

/**
 * Performs an AJAX GET request.
 * @param {string} controller - The controller name.
 * @param {string} action - The action name.
 * @param {string | undefined} param - Additional parameters for the request.
 * @returns {Promise<any>} - A promise resolving to the AJAX response.
 */
function performAjaxCall(controller: string, action: string, param: string | undefined): Promise<any> {
    const paramString : string = param || ""; // Ensure param is a string
    const separator = paramString.toString().startsWith("?") ? "" : "/";
    const url = `/${controller}/${action}${separator}${paramString}`;

    return new Promise((resolve, reject) => {
        $.ajax({
            type: "GET",
            url: url,
            success: resolve,
            error: reject,
        });
    });
}